// One format for issues everywhere on the site: "Volume 1, Issue 1 | January–June 2026"

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const numberOf = (val, fallback = '1') => {
  const match = String(val ?? '').match(/\d+/);
  return match ? String(parseInt(match[0], 10)) : fallback;
};

/**
 * Issue period from the admin "validity" text or date:
 * "January to June 2026", "January - June 2026", "Jan – Jun 2026" -> "January–June 2026";
 * a date such as 2026-03-01 -> the half-year it falls in.
 */
export const formatIssuePeriod = (validity) => {
  if (!validity) return '';
  const text = String(validity).trim();

  if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
    const d = new Date(text);
    if (!isNaN(d.getTime())) {
      return d.getMonth() < 6 ? `January–June ${d.getFullYear()}` : `July–December ${d.getFullYear()}`;
    }
  }

  const fullMonth = (word) => MONTHS.find((m) => m.toLowerCase().startsWith(word.toLowerCase().slice(0, 3))) || word;
  const range = text.match(/^([A-Za-z]+)\.?\s*(?:to|–|—|-)\s*([A-Za-z]+)\.?,?\s*(\d{4})$/i);
  if (range) return `${fullMonth(range[1])}–${fullMonth(range[2])} ${range[3]}`;

  return text.replace(/\s*(?:–|—|-)\s*/g, '–');
};

/** "Volume 1, Issue 1" */
export const formatVolumeIssue = (vol, issue) => `Volume ${numberOf(vol)}, Issue ${numberOf(issue)}`;

/** "Volume 1, Issue 1 | January–June 2026" (the period is left out when unknown) */
export const formatIssueTitle = (vol, issue, validity) => {
  const period = formatIssuePeriod(validity);
  return period ? `${formatVolumeIssue(vol, issue)} | ${period}` : formatVolumeIssue(vol, issue);
};

/** Same, for an issue record from the admin ({ Vol, issue, validity }) */
export const formatIssueRecord = (record) =>
  record ? formatIssueTitle(record.Vol, record.issue, record.validity) : '';
